export const CO2 = () => (
  <>
    CO<sub className='text-[8px]'>2</sub>e
  </>
);
